export const parseUploadDestination = (destination) => {
  if (destination === 'user') {
    return '/users/me/storage';
  }

  if (destination?.startsWith('events/')) {
    return `/events/${destination.replace('events/', '')}/storage`;
  }

  if (destination?.startsWith('workspaces/')) {
    return `/workspaces/${destination.replace('workspaces/', '')}/storage`;
  }

  return '/workspace/storage';
};
